module.exports = __webpack_public_path__ + "img/1.9294f75e.jpg";